import { render, staticRenderFns } from "./Cars.vue?vue&type=template&id=12a8668c&"
import script from "./Cars.vue?vue&type=script&lang=js&"
export * from "./Cars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports